module.exports = __webpack_public_path__ + "static/media/negotiate@2x.34a3797c.png";